
import styled from "@emotion/styled";
export const StyledHomeContent = styled.div`
    color: #fff;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100vw;
  `;

  export const StyledTitle = styled.h2`
    font-family: 'Roboto Condensed';
    font-weight: 900;
    font-size: 48px;
    line-height: 56.25px;
    letter-spacing: 0%;
    text-align: center;
    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 37.5px;
    }
  `;

  export const StyledDescription = styled.span`
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 21px;
    line-height: 24.61px;
    letter-spacing: 0%;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.5;
    margin-bottom: 32px;
    word-wrap: break-word;
  `;
  export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 16px 8px;
    background-color: transparent;
    width: 100vw;
    height: auto;
  `;

  export const CustomButton = styled.a`
    width: 222px;
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #DAE753;
    background-color: transparent;
    text-transform: uppercase;
    color: #DAE753;
    font-family: 'Roboto Condensed';
    font-weight: 700;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    text-align: center;
    cursor: pointer !important;
  `;

  export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px 20px;
    width: 100vw;
    gap: 16px;
    @media (max-width: 768px) {
    align-items: center;
      justify-content: center;
      padding: 0px 20px;
      margin-top: -50px;
    }
  `;

  export const CardsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    gap: 24px;
    @media (max-width: 1100px) {
      flex-direction: column;
    }
  `;

  export const ContentHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    width: 100vw;
    padding: 0 20px;
  `;
  export const Container = styled.div`
    display: flex;
    overflow: hidden;
    h2 {
      text-align: center;
    }
  `;